<div style="position: relative">
  <div class="loader-overlay" *ngIf="status === 'loading' && withOverlayLoader">
    <mat-spinner class="absolute-centered" diameter="50"></mat-spinner>
  </div>

  <button mat-icon-button mat-dialog-close class="close-btn" aria-label="close checkout dialog"
    [trackClick]="{page: 'Clicked X Button'}">
    <mat-icon>close</mat-icon>
  </button>

  <div class="inline-checkout-wrapper" *ngIf="status !== 'error'; else errorState">
    <div *ngIf="!dialogData.paymentFailureSummaryData; else paymentFailureSummary" class="billing-details-wrapper">
      <app-billing-details (appOutsideClick)="onOutsideClick($event)">
        <p description>{{ 'billing.reviewBillingDetails' | translate }}</p>

        <!-- Plan -->
        <div billing-detail-item class="row-item-details" data-testid="checkout-plan-section">
          <div class="title-content">
            <span class="row-section-title">{{ 'billing.plan' | translate }}</span>
          </div>
          <app-bill-details-row
            [label]="currentPlan?.productId ? (('billing.' + currentPlan.productId) | lowercase | translate) : ''"
            [content]="planPriceDescription"
            [price]="formatLocalizedPrice(totalPlanCostWithoutAddonsAndDiscounts)">
          </app-bill-details-row>
        </div>

        <mat-divider class="mat-border-v2"></mat-divider>

        <!-- Add-ons -->
        <div billing-detail-item *ngIf="currentPlan.paymentModel.hasAddons" class="row-item-details" data-testid="checkout-addons-section">
          <div class="title-content">
            <span class="row-section-title">{{ 'billing.addOns' | translate }}</span>
            <mat-icon class="info-icon" [matTooltip]="'billing.addOnsTooltip' | translate" matTooltipPosition="after"
              (click)="$event.stopPropagation()" (keydown)="$event.stopPropagation()"
              [matTooltipClass]="'custom-tooltip'">
              info_outline
            </mat-icon>
          </div>
          <div *ngFor="let item of addons">
            <app-bill-details-row
              [label]="item.name | translate"
              [content]="item.shortDescription"
              [price]="formatLocalizedPrice(item.totalPrice)">
            </app-bill-details-row>
          </div>
        </div>

        <mat-divider class="mat-border-v2" *ngIf="currentPlan.paymentModel.hasAddons"></mat-divider>

        <!-- Other -->
        <div billing-detail-item class="row-item-details" *ngIf="hasOtherItems" data-testid="checkout-other-section">
          <div class="title-content">
            <span class="row-section-title">{{ 'billing.competitors.other' | translate }}</span>
          </div>
          <div>
            <span *ngIf="status !== 'updating'; else contentLoader">
              <app-bill-details-row *ngIf="taxAmount > 0"
                [label]="removeSpaces('billing.tax' | translate)"
                [price]="formatLocalizedPrice(taxAmount)">
              </app-bill-details-row>
            </span>
            <span *ngIf="status !== 'updating'; else contentLoader">
              <app-bill-details-row *ngIf="!!normalizedPromotionalDiscount"
                [label]="'billing.disc' | translate"
                [badge]="promotionalDiscountBadge"
                [price]="formatLocalizedPrice(normalizedPromotionalDiscount * -1)">
              </app-bill-details-row>
            </span>
            <span *ngIf="status !== 'updating'; else contentLoader">
              <app-bill-details-row *ngIf="!!annualBillingDiscount"
                [label]="'billing.annualDiscount' | translate"
                [price]="formatLocalizedPrice(annualBillingDiscount * -1)">
              </app-bill-details-row>
            </span>
          </div>
        </div>

        <mat-divider class="mat-border-v2" *ngIf="hasOtherItems"></mat-divider>

        <!-- Total -->
        <div billing-detail-item class="total-bill-price row-item-details" data-testid="checkout-total">
          <ng-container *ngIf="status !== 'updating'; else contentLoader">
            <span class="total-bill-price-text">{{ totalBillLabelKey | translate }}</span>
            <span class="total-bill-price-text">{{ formatLocalizedPrice(totalBillAmount) }}</span>
          </ng-container>
        </div>

        <div footer-content *ngIf="dialogData?.socialProof" style="padding-top: 58px;">
          <app-billing-logos-section
            [opacity]="'1'"
            [logos]="companyLogos"
            alignment="start center"
            billing-detail-item
            [applySocialProofClass]="false">
          </app-billing-logos-section>
        </div>
      </app-billing-details>
    </div>

    <!--  Paddle Section-->
    <div class="checkout-column">
      <nav>
        <button [class.enabled]="isPaddleUpdated" [trackClick]="{page: 'Clicked Personal info'}" class="breadcrumb"
          (click)="breadcrumbClick()">
          <span [class.enabled]="isPaddleUpdated" class="breadcrumb-text">{{
            'billing.checkoutDialog.breadcrumb.personalInfo' | translate }}</span>
        </button>
        <ng-container *ngIf="isPaddleUpdated">
          <button class="breadcrumb">
            <span class="breadcrumb-text">{{ 'billing.checkoutDialog.breadcrumb.paymentInfo' | translate }}</span>
          </button>
        </ng-container>
      </nav>

      <!-- Here goes the Paddle checkout iframe -->
      <div class="inline-checkout-container" [attr.data-sandbox]="paymentProvider.isSandbox"></div>
    </div>
  </div>
</div>

<ng-template #errorState>
  <app-empty-state [icon]="'error'">
    <h3 title>{{ (isUnsupportedCountry ? 'billing.checkoutDialog.unsupportedCountry.title' :
      'billing.checkoutDialog.loadError.title')| translate }}</h3>
    <div description [ngClass]="{'unsupported-country': isUnsupportedCountry}" [innerHTML]="(isUnsupportedCountry ?
      'billing.checkoutDialog.unsupportedCountry.description' : 'billing.checkoutDialog.loadError.description')|
      translate"> </div>
  </app-empty-state>
</ng-template>

<ng-template #paymentFailureSummary>
  <app-payment-summary [inputData]="dialogData.paymentFailureSummaryData"></app-payment-summary>
</ng-template>

<ng-template #contentLoader>
  <mat-spinner diameter="18" content></mat-spinner>
</ng-template>
